
export default {
  create: 'Aktivität erstellen',
  createProgramme: 'KI-Programm erhalten',
  aiProgramme: 'KI-Aktivitätsprogramm',
  name: 'Aktivitätsname',
  placeholder: 'Bitte geben Sie den Namen der Aktivität ein',
  total: 'Gesamtzahl der Anmeldungen',
  tips: {
    total: 'Anmeldezahlen enthalten keine Stornierungen',
    income: 'Einkommen ohne Rückerstattungen, Trinkgelder und Produktverkäufe'
  },
  income: 'Gesamteinkommen aus Anmeldungen',
  likes: 'Gesamtzahl der Likes',
  table: {
    name: 'Aktivitätsname',
    status: 'Aktivitätsstatus',
    total: 'Gesamtzahl der Anmeldungen',
    today: 'Anmeldungen heute',
    last_week: 'Anmeldungen letzte Woche',
    create: 'Erstellungszeit',
    update: 'Aktualisierungszeit',
    start: 'Startzeit',
    end: 'Endzeit',
    operate: 'Betrieb',
    oper: {
      data: 'Anmeldedaten',
      config: 'Inhaltskonfiguration',
      progress: 'Fortschrittskonfiguration',
      display: 'Aktivitätsanzeige',
      screen: 'Datenleinwand',
      share: 'Aktivität teilen',
      more: 'Weitere Funktionen',
      mores: {
        setting: 'Anzeigeeinstellungen',
        ad: 'Werbeeinstellungen',
        live: 'Bildliveübertragung',
        video: 'Tolle Videos',
        qrcode: 'Check-in QR-Code',
        gift: 'Geschenke und Preise'
      }
    },
    total_number: 'Gesamt {total} Einträge'
  },
  create_form: {
    placeholder: 'Bitte geben Sie ein',
    status: {
      '是否确认立刻发布活动?': 'Möchten Sie die Aktivität sofort veröffentlichen?'
    },
    content: {
      title: 'Inhalt der Aktivität',
      name: {
        label: 'Aktivitätsname',
        hover: 'Geben Sie den Namen für diese Aktivität ein, z.B.: Erste Kinderkunstausstellung'
      },
      cycle: {
        label: 'Aktivitätszyklus',
        hover: 'Gesamtzeitraum, vom Beginn bis zum Ende der Aktivität: z.B.: 2024.01.20 ~ 2024.05.20; falls nicht festgelegt, bitte einen Zeitraum schätzen'
      },
      stage: {
        title: 'Aktivitätsphase',
        desc: 'Derzeit kann nur eine Phase erstellt werden. Bei mehreren unterschiedlichen Phasen erstellen Sie bitte zunächst die Aktivität und klicken Sie dann in der Aktivitätsliste auf "Erweiterte Konfiguration" für diese Aktivität.',
        name: {
          title: 'Phasenname',
          hover: 'Name der Aktivitätsphase, derzeit kann nur eine Phase erstellt werden; z.B.: Erste Runde oder Zweite Runde oder Vorauswahl oder Finale'
        },
        start: {
          title: 'Anmeldezeit',
          hover: 'Start- und Endzeit der Anmeldung für diese Phase, bitte geben Sie die genaue Minute und Sekunde an. Hinweis: Außerhalb der Anmeldezeit ist keine Anmeldung möglich; falls nicht entschieden, kann es später ausgefüllt werden'
        },
        hold: {
          title: 'Veranstaltungszeit',
          hover: 'Start- und Endzeit dieser Phase, bitte geben Sie die genaue Minute und Sekunde an, z.B.: Offline-Ausstellungszeitraum oder Preisverleihungszeitraum; falls nicht entschieden, kann es später ausgefüllt werden'
        }
      },
      poster: {
        title: 'Veranstaltungsplakat',
        upload: 'Zum Hochladen klicken',
        tips: {
          _1: 'Tipp: Unterstützt .jpg, .png Bildformate; maximale Bildgröße darf 5MB nicht überschreiten; Bildproportionen möglichst 1:1 halten, Mindestgröße 860px*860px',
          _2: 'Das Bild wird oben auf der Teilnehmerseite angezeigt, klicken Sie auf Beispiel anzeigen'
        }
      },
      detail: {
        desc: 'Die drei Abschnitte werden auf der mobilen Anmeldeseite angezeigt und sind für Teilnehmer sichtbar, klicken Sie auf Beispiel anzeigen',
        placeholder: 'Bitte hier eingeben',
        title: {
          _1: 'Veranstaltungsübersicht',
          _2: 'Anmelderegeln',
          _3: 'Organisation'
        }
      }
    },
    group: {
      title: 'Gruppeninformationen',
      desc: 'Derzeit kann nur eine Gruppenaktivität erstellt werden. Bei mehreren unterschiedlichen Gruppenaktivitäten erstellen Sie bitte zunächst die Aktivität und klicken Sie dann in der Aktivitätsliste auf "Aktivitätskonfiguration - Wettbewerbskonfiguration" für diese Aktivität. Das Aktivitätssystem unterstützt, dass verschiedene Gruppenaktivitäten unterschiedliche Anmeldegebühren, Anmeldeformulare, Grundauswahlkriterien, Anmeldeformen usw. einrichten können',
      category: {
        title: 'Aktivitätskategorie',
        hover: 'z.B.: Kunst; Tanz;',
        add: 'Kategorie hinzufügen',
        name: 'Kategoriename'
      },
      group: {
        title: 'Aktivitätsgruppen',
        hover: 'z.B.: Jugendgruppe; Erwachsenengruppe;',
        add: 'Gruppe hinzufügen',
        name: 'Gruppenname'
      },
      form: {
        title: 'Anmeldeformular',
        hover: 'Informationen, die Teilnehmer ausfüllen müssen; verschiedene Kategorien oder Gruppen können unterschiedliche Anmeldeformulare verwenden',
        create: 'Anmeldeinformationen für Aktivität erstellen'
      },
      charge: {
        title: 'Anmeldegebühr',
        hover: 'Verschiedene Kategorien oder Gruppen können unterschiedliche Gebühren festlegen'
      },
      config: {
        title: 'Detaillierte Konfigurationseinstellungen:',
        hover: 'Verschiedene Kategorien oder Gruppen können unterschiedliche Auswahlregeln, Auswahlkriterien, Auswahlmethoden, Auswahlpersonenzahl, Veröffentlichungszeitpunkt der Auswahlsituation usw. festlegen',
        repeat: {
          title: 'Wiederholte Anmeldung in der gleichen Gruppe:',
          hover: 'Darf sich ein Benutzer mehrmals mit den gleichen Informationen für eine Gruppenaktivität anmelden',
          default: 'Aus'
        },
        pass: {
          title: 'Anmeldung genehmigen:',
          hover: 'Nach Anmeldeübermittlung durch den Benutzer, ob die Anmeldung standardmäßig durch die Systemprüfung als gültig/ungültig beurteilt wird',
          default: 'Automatisch genehmigen',
          prepay: 'Erst prüfen, dann zahlen',
          postpay: 'Erst zahlen, dann prüfen'
        },
        show: {
          title: 'Anzeige im Anmeldezentrum:',
          hover: '"Persönlich": Anmeldung mit Informationen für eine Person; "Team": Anmeldung mit Informationen mehrerer Personen, die sich ein Werk teilen',
          default: 'Anzeigen'
        },
        form: {
          title: 'Gruppenanmeldeform:',
          hover: '"Persönlich": Anmeldung mit Informationen für eine Person; "Team": Anmeldung mit Informationen mehrerer Personen, die sich ein Werk teilen',
          default: 'Persönlich',
          team: 'Team',
          min: 'Minimale Teamgröße:',
          max: 'Maximale Teamgröße:'
        },
        base: {
          title: 'Basisbewertungsfunktion:',
          hover: 'Ob die Basisbewertungsfunktion aktiviert werden soll; z.B.: Aktivieren oder Deaktivieren',
          default: 'Aus'
        },
        commission: {
          title: 'Partnerkommission:',
          hover: 'Partner als nachgeordneter Vertriebskanal des Veranstalters, Prozentsatz der Provisionen von Anmeldegebühren',
          default: 'Aus'
        },
        inherit: {
          title: 'Bewertungsnummernvererbung:',
          hover: 'Im Hauptmenü unter erweiterte Bewertungsverwaltung können Bewertungsnummern für Anmeldungen festgelegt werden, die beim Aufstieg in die nächste Runde übernommen werden können',
          default: 'Aus'
        }
      }
    },
    session: {
      title: 'Sitzungsinformationen',
      desc: 'Hinweis: Die aktuelle Sitzungserstellung ist nur mit der im vorherigen Schritt erstellten Gruppenaktivität verknüpft. Wenn mehrere Gruppenaktivitäten Sitzungspläne haben, schließen Sie bitte zuerst die erste Erstellung der Aktivität ab, gehen Sie zur Aktivitätsverwaltung und klicken Sie auf "Aktivitätskonfiguration - Wettbewerbskonfiguration - Sitzungskonfiguration", um dort die Konfiguration vorzunehmen. Eine einzelne Gruppe kann mehrere Sitzungen erstellen, und verschiedene Gruppen können unterschiedliche Sitzungen erstellen.',
      name: 'Gruppenaktivität',
      number: {
        title: 'Teilnehmerzahl',
        hover: 'Die Teilnehmerzahl wird für jede einzelne Sitzung festgelegt. Wenn es mehrere Sitzungen gibt, muss die Anzahl für jede Sitzung separat festgelegt werden',
        config: 'Einstellungen',
        default: 'Unbegrenzt'
      },
      arrange: {
        title: 'Sitzungsanordnung',
        hover: 'Wenn keine entsprechenden Sitzungstermine festgelegt sind, können Sie diese schließen; wenn Sitzungstermine bereits vorhanden sind, können Sie diese aktivieren und einrichten, online und offline werden unterstützt',
        default: 'Aus'
      },
      form: 'Sitzungsform:',
      online: 'Online-Adresse',
      offline: 'Regionsauswahl',
      address: 'Detaillierte Adresse',
      time: 'Sitzungszeit'
    }
  },
  title: 'Aktivitäten',
  list: {
    title: 'Aktivitätsliste',
    search: 'Suchen',
    filter: 'Filter',
    export: 'Exportieren',
    import: 'Importieren',
    create: 'Neue Aktivität',
    edit: 'Bearbeiten',
    delete: 'Löschen',
    view: 'Anzeigen',
    refresh: 'Aktualisieren',
    columns: {
      id: 'ID',
      name: 'Name',
      description: 'Beschreibung',
      startDate: 'Startdatum',
      endDate: 'Enddatum',
      status: 'Status',
      type: 'Typ',
      createdBy: 'Erstellt von',
      createdAt: 'Erstellt am',
      updatedAt: 'Aktualisiert am'
    }
  },
  form: {
    create: {
      title: 'Neue Aktivität erstellen',
      submit: 'Erstellen',
      cancel: 'Abbrechen'
    },
    edit: {
      title: 'Aktivität bearbeiten',
      submit: 'Speichern',
      cancel: 'Abbrechen'
    },
    fields: {
      name: {
        label: 'Name',
        placeholder: 'Geben Sie den Namen ein',
        required: 'Name ist erforderlich'
      },
      description: {
        label: 'Beschreibung',
        placeholder: 'Geben Sie die Beschreibung ein'
      },
      startDate: {
        label: 'Startdatum',
        placeholder: 'Wählen Sie das Startdatum',
        required: 'Startdatum ist erforderlich'
      },
      endDate: {
        label: 'Enddatum',
        placeholder: 'Wählen Sie das Enddatum',
        required: 'Enddatum ist erforderlich'
      },
      status: {
        label: 'Status',
        placeholder: 'Wählen Sie den Status',
        required: 'Status ist erforderlich'
      },
      type: {
        label: 'Typ',
        placeholder: 'Wählen Sie den Typ',
        required: 'Typ ist erforderlich'
      }
    }
  },
  messages: {
    create: {
      success: 'Aktivität erfolgreich erstellt',
      error: 'Fehler beim Erstellen der Aktivität'
    },
    edit: {
      success: 'Aktivität erfolgreich aktualisiert',
      error: 'Fehler beim Aktualisieren der Aktivität'
    },
    delete: {
      success: 'Aktivität erfolgreich gelöscht',
      error: 'Fehler beim Löschen der Aktivität',
      confirm: 'Möchten Sie diese Aktivität wirklich löschen?'
    },
    export: {
      success: 'Aktivitäten erfolgreich exportiert',
      error: 'Fehler beim Exportieren der Aktivitäten'
    },
    import: {
      success: 'Aktivitäten erfolgreich importiert',
      error: 'Fehler beim Importieren der Aktivitäten'
    }
  }
} 


// WEBPACK FOOTER //
// ./src/langs/de/activity.js